import {
  SET_EMAIL,
} from "../types";

export function setConsumerEmail(email) {
  return { type: SET_EMAIL, payload: email };
}